export const API_PATH_ApiDeviceMgmtRegionChangeOrder = '/services/devices-mgtm/apiDeviceMgmtRegionChangeOrder';
